<template>
  <div class="page">
    <PageHeader :links="headLinks" />

    <div class="pageMain">
      <div class="topbar m-b-25 d-flex flex-j-between">
        <div class="searchBox">
          <el-input placeholder="稿件标题" v-model="f_title" class="input-with-select">
            <el-button slot="append" icon="el-icon-search" @click="loadData">搜索</el-button>
          </el-input>
        </div>
      </div>

      <el-row>
        <el-col :span="24">
          <el-table ref="tableData" :data="tableData" border style="width: 100%">
            <el-table-column type="index" width="50"> </el-table-column>
            <el-table-column prop="sn" label="稿件编号" width="100">
              <template slot-scope="scope">
                <span class="sn">{{ scope.row.sn }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="title" label="稿件标题" min-width="200">
              <template slot-scope="scope">
                <h3>{{ scope.row.title }}</h3>
              </template>
            </el-table-column>

            <el-table-column prop="subjectName" :label="subName"></el-table-column>

            <el-table-column prop="authorName" label="作者"></el-table-column>

            <el-table-column prop="createTime" label="投稿时间">
              <template slot-scope="scope">
                {{ scope.row.createTime | datefmt2("YYYY-MM-DD HH:mm:ss") }}
              </template>
            </el-table-column>

            <el-table-column prop="lockTime" label="锁定时间">
              <template slot-scope="scope">
                {{ scope.row.lockTime | datefmt2("YYYY-MM-DD HH:mm:ss") }}
              </template>
            </el-table-column>

            <el-table-column fixed="right" label="操作" align="center">
              <template slot-scope="scope">
                <el-button size="mini" type="primary" v-if="scope.row.step == 50" @click="showProcess(scope.row.id)">进入评审</el-button>
                <el-button size="mini" type="warning" v-else-if="scope.row.step == 52" @click="showProcess(scope.row.id)">再次评审</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-col>
      </el-row>

      <div style="margin: 20px 0 0 -5px">
        <el-pagination background layout="prev, pager, next" :total="total" :page-size="pageSize" :current-page="curPage" @current-change="pageChange"> </el-pagination>
      </div>
    </div>

    <el-drawer :title="drawerTitle" :visible.sync="drawer" :direction="'rtl'" :size="700" :destroy-on-close="true" :wrapperClosable="false">
      <div class="flex-1 d-flex flex-column">
        <div class="flex-1" style="padding: 0 20px 20px 20px">
          <ArticleProcess ref="ArticleProcess" :articleId="curArticleId" role="EXPERT" @examineSuccess="examineSuccess" @examineReject="examineReject"></ArticleProcess>
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import PageHeader from "@/components/PageHeader.vue"
import ArticleProcess from "@/components/ArticleProcess.vue"
import expertApi from "@/api/expert"
/**
 * 待评审页面
 * 步骤,100退稿。
 * 10作者提交稿件，
 * 20待编辑首次审稿，21作者一次改稿,22编辑第二次审稿。
 * 30交审稿费。
 * 40专家首次审稿，41作者二次改稿,42专家第二次审稿。
 *
 * 50编辑查重，51作者三次改稿，52编辑二次查重。
 * 60登记版面费，出录用通知；
 * 70交版面费。
 * 80填写发票信息。
 * 90完成。
 */
export default {
  components: { PageHeader, ArticleProcess },
  data() {
    return {
      subName: process.env.VUE_APP_PLATFORM == "dx" ? "栏目" : "科目",
      headLinks: [{ path: "", title: "待审稿件" }],
      subjects: [],
      f_subjectId: -1,
      f_title: "",
      curPage: 1,
      pageSize: 10,
      tableData: [],
      total: 0,
      drawer: false,
      drawerTitle: "",
      curArticleId: 0,
    }
  },

  mounted() {
    this.loadData()
  },

  methods: {
    pageChange(curPage) {
      this.curPage = curPage
      this.loadData()
    },

    loadData() {
      expertApi.articleListAudit(this.f_subjectId, this.f_title, "", "", this.curPage, this.pageSize).then((res) => {
        this.tableData = res.rows
        this.total = res.total
      })
    },

    openDraw(title) {
      this.drawer = true
      this.drawerTitle = title
    },

    showProcess(articleId) {
      this.openDraw("查看流程")
      this.curArticleId = articleId
    },

    examineReject() {
      this.drawer = false
      setTimeout(() => {
        this.loadData()
      }, 1500)
    },

    examineSuccess() {
      setTimeout(() => {
        this.loadData()
      }, 1500)
    },
  },
}
</script>

<style scoped>
.searchBox::after {
  content: "";
  display: block;
  clear: both;
}

>>> .el-drawer__body {
  display: flex;
}
/* 
.searchItem label{
    width:100px;
    float:left;
    text-align: center;
}
.searchItem>div{
    margin-left: 120px;
}
.vTag{
    line-height: 30px;
    border:1px solid #ccc;
    border-radius: 3px;
    text-align: center;
    display: inline-block;
    margin-right: 10px;
    padding: 0 15px;
    font-size: 14px;
    cursor: pointer;
    
}
.vTag.actvie{
    background-color: #409eff;
    color:#FFF;
}
*/
</style>
